/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { VersionDto } from '../models/version-dto';

@Injectable({
  providedIn: 'root',
})
export class VersionControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCurrentVersion
   */
  static readonly GetCurrentVersionPath = '/api/v1/version';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentVersion$Response(params?: {
  }
): Observable<StrictHttpResponse<VersionDto>> {

    const rb = new RequestBuilder(this.rootUrl, VersionControllerService.GetCurrentVersionPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: '*/*',
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VersionDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCurrentVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentVersion(params?: {
  }
): Observable<VersionDto> {

    return this.getCurrentVersion$Response(params).pipe(
      map((r: StrictHttpResponse<VersionDto>) => r.body as VersionDto)
    );
  }

}
